<lib-page-container title="Receipt details" [loading]="screen.isLoading()" [version]="appVersion.version"
  [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions></div>
  <div lib-page-body>
    <mat-tab-group mat-stretch-tabs="false" class="tabs">
      <mat-tab label="Data">
        <div class="flex-row gap-16 mt-16">
          <div class="flex-column gap-16">
            <mat-card appearance="outlined" class="p-16">
              <div class="flex-row gap-16 flex-wrap">
                <mat-form-field>
                  <mat-label>Scan Date</mat-label>
                  <input matInput [formControl]="scanDateControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>User Phone</mat-label>
                  <input matInput [formControl]="userPhoneControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Verify Doc Id</mat-label>
                  <input matInput [formControl]="verifyDocIdControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Invoice Date</mat-label>
                  <input matInput [matDatepicker]="picker" (dateChange)="detailsChangedHandler()"
                    placeholder="Choose a date" [formControl]="invoiceDateControl">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="wid-100">
                  <mat-label>Invoice Hour</mat-label>
                  <input matInput type="text" [ngxMatTimepicker]="timePicker" placeholder="" [format]="24"
                    [formControl]="timeControl" readonly>
                  <ngx-mat-timepicker #timePicker></ngx-mat-timepicker>
                  <ngx-mat-timepicker-toggle matSuffix [for]="$any(timePicker)">
                    <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
                  </ngx-mat-timepicker-toggle>

                </mat-form-field>

                <mat-form-field>
                  <mat-label>Invoice No</mat-label>
                  <input matInput [formControl]="invoiceNumberControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Reference No</mat-label>
                  <input matInput [formControl]="referenceNumberControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Vendor</mat-label>
                  <input matInput [formControl]="vendorNameControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Campaign</mat-label>
                  <input matInput [formControl]="campaignNameControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Campaign ID</mat-label>
                  <input matInput [formControl]="campaignIdControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Stage</mat-label>
                  <input matInput [formControl]="stageControl">
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Suspect group</mat-label>
                  <input matInput [formControl]="suspectGroupControl">
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card appearance="outlined">
              <mat-card-content>
                <div class="flex-column gap-16">
                  <app-receipt-lines [receipt]="receipt" (detailsChanged)="detailsChangedHandler()"
                  (tagsChanged)="tagsChangedHandler($event)" [data]="raw" #receiptLines></app-receipt-lines>

                  <lib-button class="wid-170" [fullWidth]="true" *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" variant="raised" [disabled]="saveDisabled" color="primary" (buttonClick)="submit()">{{saveText}}</lib-button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <lib-photo (click)="onImageClick()" [url]="receipt?.receiptUrl" [width]="'400px'" [height]="'600px'"
              [radius]="'5px'"></lib-photo>
        </div>
      </mat-tab>

      <mat-tab label="Json">
        <mat-card appearance="outlined" class="mt-16">
          <mat-card-content>
            <pre style="overflow-x:scroll; white-space:pre-wrap;">{{ raw | json }}</pre>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <mat-tab label="History">
        <mat-card appearance="outlined" class="mt-16">
          <mat-card-content>
            <lib-ngx-data-table class="history-table" rowHeight="auto" [data]="receiptChanges" [columns]="columns" [selectionType]="undefined"></lib-ngx-data-table>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </div>
</lib-page-container>